import { Button } from "Components/CustomComponents";
import React from "react";
import styles from "./index.module.scss";

interface TabsProps {
    tabs: { label: string, value: string, icon?: React.ReactNode, active_icon?: React.ReactNode }[];
    current: string;
    onChange: (value: string) => void;
    align?: 'space-between' | 'center' | 'flex-end' | 'flex-start';
    itemStyle?: React.CSSProperties;
    containerStyles?: React.CSSProperties;
    classes?: string
}

const Tabs: React.FC<TabsProps> = ({ tabs = [], current = '', onChange = () => { }, align = 'space-between', itemStyle = {}, containerStyles = {}, classes = '' }) => {

    return (
        <div className={`${styles.TabsContainer} ${classes}`}>
            <div
                style={{ ...{ overflow: 'auto', width: '100%' }, ...containerStyles }}
                className="d-flex overflow-x-scroll"
            >
                <div className={`${styles.tabs} ${styles[align]}`}>
                    {tabs.map((item, index) => {
                        return <Button
                            key={index}
                            className={`${styles.tab} ${item.value === current ? styles.active : ""} w-fit-content fs-7 blueBtnBg`}
                            style={itemStyle}
                            isOutlined={item.value !== current}
                            onClick={() => onChange(item.value)}
                            text={
                                <>
                                    {item?.icon ? <div className={styles.iconContainer}>
                                        <span className={styles.icon}>{item.icon}</span>
                                        <span className={styles.active_icon}>{item.active_icon}</span>
                                    </div> : ""}
                                    <span>{item.label}</span>
                                </>
                            }
                        />
                    })}
                </div>
            </div>
        </div >
    )
}


export default Tabs;